import React from "react";
import Circle from "react-icons/lib/fa/circle-o";
import Checked from "react-icons/lib/fa/dot-circle-o";
import "./index.scss";

export default function Radio(props) {
  const { checked, disabled, label = "" } = props;

  let className = 'radio-input'
  if (checked) className += ' checked'

  return (
    <div>
      <div className={className} style={props.style} onClick={onClick}>
        {renderIcon()}
        <div className="radio-label">{label}</div>
      </div>
    </div>
  );

  function renderIcon() {
    if (checked) return <Checked />;
    else return <Circle />;
  }

  function onClick() {
    if (disabled) return;
    if (props.onClick) props.onClick();
  }
}

export function LanguageRadio(props) {
  const { label, checked, onClick } = props;

  let className = "language-radio";
  if (checked) className += " checked";

  return (
    <div className={className} onClick={onClick} style={props.style}>
      <div className="locale">{label}</div>
      <Radio checked={checked} style={{ fontSize: 20 }} />
    </div>
  );
}
